import { getHotjarId, identifyHotjar, initHotjar } from '@narf/hotjar'
import { CATEGORY, withOneTrust } from '@narf/onetrust'
import { useUnauth } from '@narf/unauth'

import React from 'react'

import { useAuth2 } from 'context/auth2'

const Hotjar = () => {
  const { siteId: siteIdAuth2, memberId } = useAuth2()
  const { siteId: siteIdUnauth } = useUnauth()
  const siteId = siteIdAuth2 || siteIdUnauth
  const [done, setDone] = React.useState(false)
  React.useEffect(() => {
    if (siteId) {
      withOneTrust(() => {
        initHotjar(getHotjarId(siteId), () => {
          setDone(true)
        })
      }, CATEGORY.C0003)
    }
  }, [siteId])

  React.useEffect(() => {
    if (done && memberId) {
      identifyHotjar(memberId)
    }
  }, [done, memberId])

  return null
}

export default Hotjar
